<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-repeat-one`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42.002 22.11v6.023c0 5.545-4.477 10.04-10 10.04H18v3.595a1 1 0 01-1.563.826l-8.23-5.605a1 1 0 01-.004-1.65l8.23-5.664A1 1 0 0118 30.5v3.658h14.002c3.313 0 6-2.697 6-6.024V22.11h4zM26.05 18v11.664h-2.86V21.08L21 22.852v-3.08L23.19 18h2.86zm4.952-13a1 1 0 01.563.173l8.23 5.605a1 1 0 01.004 1.65l-8.23 5.664a1 1 0 01-1.567-.823V13.61H16c-3.314 0-6 2.697-6 6.023v6.024H6v-6.024c0-5.545 4.477-10.04 10-10.04h14.002V6a1 1 0 011-1z"/></svg>
</template>
<script>

export default {
  name: 'IconRepeatOne',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
